// removed by extract-text-webpack-plugin
module.exports = {"hidden":"Y79Wq","visuallyhidden":"_3VE4j","hide-text":"EKQvE","center":"_19Nx-","noprint":"_2IKIn","listItem":"_2SCv-","authorList":"_2r2yV","image":"UyIR4","root":"ae_j3 _25KE7","description":"_13x6q"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-byline/styles/sports.scss
 ** module id = 991
 ** module chunks = 2
 **/